<template>
    <!-- 互动问答--bar -->
    <div class='qa-list-bar' v-if="knowledgeInfo.Statistics" :class="{'hide-bar':CallCommentInput,'higher-zindex':showCocTip}">
        <div class='qa-list-inp' @click="callCommentInput">{{ cPlaceholder }}</div>
<!-- <div class='qa-list-inp' @click="callCommentInput">写下我的留言或提问...{{ cPlaceholder }}</div> -->
        <div class='qa-list-btn'>
            <div class='list-btn' @click='collect' :class="{'list-btn-active': knowledgeInfo.Statistics.IsCollection}">
                <img src="../../static/images/ic_07_nor.png" class="menu-svg-icon" v-if='knowledgeInfo.Statistics.IsCollection'>
                <img src="../../static/images/ic_06_nor.png" class="menu-svg-icon" v-else>
                <span>{{ knowledgeInfo.TotalCollectionCount }}</span>
            </div>
            <div class='list-btn' @click='ThumbUpDown(true)' :class="{'list-btn-active': knowledgeInfo.Statistics.IsPraise}">
                <i class="list-btn-icon thumb-up-icon"></i>
                <span>{{knowledgeInfo.Statistics.PraiseCount}}</span>
            </div>
            <div class='list-btn' @click='ThumbUpDown(false)' :class="{'list-btn-active': knowledgeInfo.Statistics.IsStepOn}">
                <i class="list-btn-icon thumb-down-icon"></i>
                <span>{{knowledgeInfo.Statistics.StepOnCount}}</span>
            </div>
        </div>
        <transition name="collect-slide-fade">
            <div class="collect-tip" @click="IKnewIt" v-if="showPopTip">
                点击收藏，方便访问
                <i class="close-icon"></i>
                <span></span>
            </div>
        </transition>
        <transition name="favorite-guide-fade">
            <div class="favorite-guide-wrapper" v-if="showCocTip">
                <div class="favorite-guide">
<!--                    <div class="fg-top">-->
<!--                        <div class="fg-top-os">-->
<!--                            <div class="fg-top-is">-->

<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="fg-mid">-->
<!--                        <h5>收藏成功</h5>-->
<!--                        <p>可在首页底部-收藏，查看收藏的内容</p>-->
<!--                    </div>-->
                    <div class="fg-bot" @click="IKnewThat"></div>
                </div>
                <div class="close-icon " @click="IKnewThat"></div>
            </div>
        </transition>
    </div>
</template>

<script>
import {SEARCH, COMMON, FAV} from '../api'

export default {
    name: 'releaveRecover',
    data() {
        return {
            buttonOnOff: true,
            ThumbUpNum: 999,//点赞
            ThumbDownNum: 9,//点踩
            isGiveThumbUp: false,
            isGiveThumbDown: false,

            // 用于指导用户收藏
            showPopTip:false,  //默认不显示气泡
            showCocTip:false,   //默认不显示收藏成功提示
            HasFav: false,  // 收藏列表是否有东西
            // VisitedPage:false,   //  是否进入访问过详情页面
            // UsedCollect:false   // 是否使用过收藏功能
        }
    },
    props: ['knowledgeInfo', 'extraInfo'],
    computed:{
        cPlaceholder() {
            console.log('extraInfo', this.extraInfo)
            // 有无匹配到comment 判断对象是否为空
            if (this.extraInfo ) {
                return '回复 ' + this.extraInfo.Name + ':'
            } else {
                return '写下我的留言或提问...'
            }
            // let placeholder = '回复 ' + this.extraInfo.Name + ':'
            // this.$store.commit('SET_InputPlaceholder', placeholder)
            // return 'placeholder' 
        },
        CallCommentInput(){
            return this.$store.getters.GET_CallCommentInput
        }
    },
    created() {
        //判断收藏列表有没有东西   再判断是否有其他的
        this.favoriteAlert()
    },
    methods: {
        favoriteAlert() {
            FAV.GetFavList({
                PageIndex: 1,
                PageSize: 10
            },).then((res) => {
                this.HasFav = (res.Data && res.Data.List && res.Data.List.length)
                if (this.HasFav) return
                if(localStorage.VisitedPage) return;
                //收藏列表没东西并且  是第一次访问页面，  则显示气泡
                localStorage.VisitedPage  = true   // 已经访问了页面
                this.showPopTip = true  //显示
                setTimeout(() => {
                    this.IKnewIt()  //无论怎样 10s后都让气泡消失
                }, 10000);
            })
        },
        IKnewIt() {
            this.showPopTip = false
        },
        IKnewThat(){
            this.showCocTip = false
        },
        //打开输入框
        callCommentInput() {
            // 有无匹配到comment 判断对象是否为空
            let placeholder = ''
            // Object.keys(this.extraInfo).length
            if (this.extraInfo) {
                placeholder = '回复 ' + this.extraInfo.Name + ':'
            } else {
                placeholder = '写下我的留言或提问...'
            }
            // console.log('extra', this.extraInfo)
            // let placeholder = '回复 ' + this.extraInfo.Name + ':'
            // this.$store.commit('SET_InputPlaceholder', '写下我的留言或提问...')
            this.$store.commit('SET_InputPlaceholder', placeholder)
            this.$store.commit('SET_CallCommentInput', true)
            // this.$store.commit('SET_CommentInfo', 'test...')
            // this.$store.commit('SET_CommentInfo', null)
        },
        collect() {
            if (!this.buttonOnOff) return;
            this.buttonOnOff = false;

            if(this.showPopTip) this.IKnewIt()  // 如果有气泡去掉提示气泡

            FAV.UpdateFav({'KBInfoId': this.knowledgeInfo.KBInfoId}).then((res) => {
                if (res.Code == 200) {
                    this.knowledgeInfo.Statistics.IsCollection = !this.knowledgeInfo.Statistics.IsCollection

                    if (this.knowledgeInfo.Statistics.IsCollection) { //收藏
                        //如果没用过收藏功能，记录使用
                        if (!localStorage.UsedCollect) {
                            localStorage.UsedCollect = true
                            this.showCocTip = true;
                        }else {
                            // 如果使用过收藏功能，使用默认toast提示收藏成功
                            this.$store.commit('SetAndCallToast', '收藏成功')
                        }

                        this.knowledgeInfo.TotalCollectionCount += 1

                        setTimeout(() => {
                            this.buttonOnOff = true
                        }, 1500);
                    } else { //取消收藏
                        this.knowledgeInfo.TotalCollectionCount -= 1
                        this.buttonOnOff = true
                    }
                } else {
                    this.buttonOnOff = true
                }
            })
        },
        //点赞/踩
        ThumbUpDown(flag) {
            if (!this.buttonOnOff) return;
            this.buttonOnOff = false;
            let Type = flag ? 1 : 0
            FAV.UpdatePraise({'KBInfoId': this.knowledgeInfo.KBInfoId, "Type": Type}).then((res) => {
                if (res.Code == 200) {
                    if (flag) {
                        if (this.knowledgeInfo.Statistics.IsPraise) {
                            this.knowledgeInfo.Statistics.IsPraise = false
                            this.knowledgeInfo.Statistics.PraiseCount--
                        } else {
                            this.knowledgeInfo.Statistics.IsPraise = true
                            this.knowledgeInfo.Statistics.PraiseCount++
                            if (this.knowledgeInfo.Statistics.IsStepOn) {
                                this.knowledgeInfo.Statistics.IsStepOn = false
                                this.knowledgeInfo.Statistics.StepOnCount--
                            }
                        }
                    } else {
                        if (this.knowledgeInfo.Statistics.IsStepOn) {
                            this.knowledgeInfo.Statistics.IsStepOn = false
                            this.knowledgeInfo.Statistics.StepOnCount--
                        } else {
                            this.knowledgeInfo.Statistics.IsStepOn = true
                            this.knowledgeInfo.Statistics.StepOnCount++
                            if (this.knowledgeInfo.Statistics.IsPraise) {
                                this.knowledgeInfo.Statistics.IsPraise = false
                                this.knowledgeInfo.Statistics.PraiseCount--
                            }
                        }
                    }
                }
                this.buttonOnOff = true
            })
        },
    }
}
</script>

<style lang='scss' type="text/scss" scoped>
    @keyframes toast {
        0% {
            opacity: 0;
        }
        30% {
            opacity: 1;
        }
        70% {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }

    .menu-svg-icon {
        width: j(40);
        height: j(40);
        margin-bottom: j(4);
        display: block;
    }

    .collect-tip {
        position: absolute;
        right: j(37);
        bottom: j(116);
        height: j(80);
        color: #FCFCFC;
        font-size: j(28);
        padding: 0 j(70) 0 j(40);
        background-color: #00BEBE;
        border-radius: j(40);
        white-space: nowrap;
        line-height: j(80);
        box-shadow:0 j(10) j(20) 0 rgba(0,190,190,0.15),0px 0px 15px 0px rgba(0,0,0,0.03);
        span {
            position: absolute;
            height: j(26);
            width: j(26);
            background-color: #00BEBE;
            bottom: j(-10);
            left: j(176);
            transform: rotate(45deg);
        }

        i {
            position: absolute;
            width: j(32);
            height: j(32);
            background:url("/static/images/icon/close_icon_def.png") no-repeat;;
            background-size: contain;
            right: j(30);
            top: 50%;
            transform: translateY(-50%);
        }
    }

    .qa-list-bar {
        width: 100%;
        height: j(100);
        box-sizing: border-box;
        position: fixed;
        bottom: 0;
        left: 0;
        padding: 0 j(40) 0 j(50);
        background: #fff;
        z-index: 1100;
        display: flex;
        align-items: center;
        opacity: 1;

        .qa-list-inp {
            width: j(390);
            height: j(50);
            border-radius: j(4);
            padding: j(10) j(20);
            margin-right: j(40);
            color: #CDCED4;
            font-size: j(28);
            display: flex;
            align-items: center;
            background: #F7F7F8;

        }

        .qa-list-btn {
            flex: 1;
            height: j(70);
            display: flex;
            align-items: center;
            justify-content: space-between;
            text-align: center;

            .list-btn {
                height: j(62);
                width: j(40);
                position: relative;

                .list-btn-icon {
                    display: block;
                    width: j(40);
                    height: j(40);
                    background-repeat: no-repeat;
                    background-size: contain;
                }

                span {
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    transform: translateX(-50%);
                    color: #9B9DA9;
                    font-size: j(18);
                    line-height: 1;
                    white-space: nowrap;
                }

                .collect-icon {
                    background-image: url('/static/images/icon/collect.png');
                }

                .thumb-up-icon {
                    background-image: url('/static/images/icon/thumb-up.png');
                }

                .thumb-down-icon {
                    background-image: url('/static/images/icon/thumb-down.png');
                }
            }

            .list-btn-active {
                span {
                    color: #00bebe;
                }

                .collect-icon {
                    background-image: url('/static/images/icon/collect-active.png');
                }

                .thumb-up-icon {
                    background-image: url('/static/images/icon/thumb-up-active.png');
                }

                .thumb-down-icon {
                    background-image: url('/static/images/icon/thumb-down-active.png');
                }
            }
        }

    }

    .hide-bar{
        transform: translateY(100%);
        opacity: 0;
    }
    .higher-zindex{
        z-index: 2100;
    }
    .footer-btn {
        width: j(130);
        height: j(60);
        background: #00BCBC;
        border: none;
        border-radius: j(30);
        font-size: j(24);
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .footer-btn-disable {
        background: #CDCED4;
    }

    .favorite-guide-wrapper{
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .favorite-guide{
            width: j(600);
            height: j(860);
            background-image: url(/static/images/icon/collect-tip.png);
            background-repeat: no-repeat;
            background-size: contain;
            text-align: center;
            border-radius:j(20);
            overflow: hidden;
            position: relative;
            .fg-top{
                height: j(480);
                background-color: #B7E8EA;
                display: flex;
                justify-content: center;
                .fg-top-os{
                    height: j(400);
                    width: j(482);
                    border-radius: 0 0 j(64) j(64);
                    background-color: #F7F7F8;
                    display: flex;
                    justify-content: center;
                }
                .fg-top-is{
                    height: j(376);
                    width: j(432);
                    border-radius: 0 0 j(42) j(42);
                    background-color: #FFFFFF;
                }
            }
            .fg-mid{
                height: j(260);
                padding:0 j(20);
                h5{
                    margin-top: j(70);
                    font-size: j(36);
                    font-weight: bold;
                    color:#363C54;
                }
                p{
                    margin-top: j(20);
                    font-size: j(28);
                    font-weight: 400;
                    color:#696D7F;
                }
            }
            .fg-bot{
                height: j(118);
                width: j(600);
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }
        .close-icon{
            margin-top: j(60);
            height: j(80);
            width: j(80);
            background: url("/static/images/icon/close-circle.png") no-repeat;
            background-size: contain;
        }
    }

    .collect-slide-fade-enter {
        transform: translateY(j(40));
        opacity: 0;
    }
    .collect-slide-fade-leave-to {
        opacity: 0;
    }
    .collect-slide-fade-enter-active{
        transition: all .3s ease 1s;
    }
    .collect-slide-fade-leave-active {
        transition: all .3s linear;
    }

    .favorite-guide-fade-enter, .favorite-guide-fade-leave-to {
        opacity: 0;
    }

    .favorite-guide-fade-enter-active, .favorite-guide-fade-leave-active {
        transition: opacity .3s ease;
    }


</style>



// WEBPACK FOOTER //
// src/components/releaveRecover.vue